import { Component, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { LogService } from 'src/app/core/services/log/log.service';
import { Router } from '@angular/router';
import { DateUtils } from 'src/app/shared/utils/date-utils';
import { State } from 'src/app/shared/enums/state.enum';
import { MessageNotification } from 'src/app/shared/models/message-notification';

@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
	planningNeedSolution = false;
	planningNeedValidation = false;
	currentWeekNumber: number;
	nextWeekNumber: number;

	displayMapButton = false;

	isPlanificatrice = false;
	isSAE = false;

	today = new Date();
	routeState = State;

	/* Partie messagerie */
	listNotification: MessageNotification[] = [];
	manyNewMessages: boolean = true;

	/* Liste des box d'information à afficher */
	boxList: {
		colorId: number;
		value: number;
		units: string;
		title: string;
		subtitle: string;
	}[] = [];

	constructor(
		private facade: FacadeService,
		private router: Router,
		private dateUtils: DateUtils
	) {
		this.router.routeReuseStrategy.shouldReuseRoute = () => false;
		this.router.onSameUrlNavigation = 'reload';
	}

	ngOnInit(): void {
		this.isPlanificatrice = this.facade.dataStorageService.isPlanificatrice();
		this.isSAE = this.facade.dataStorageService.isSAE();

		this.initDashboardVariables();

		if (this.facade.dataStorageService.isPlanificatrice()) {
			this.getViewableCenters();
			this.initializeBox();
		}

		this.getMessagingNotifications();
	}

	getViewableCenters() {
		this.facade.centerService.getAllViewableCenter().subscribe((centers) => {
			let mappedCenter: { id: number; name: string; type: number }[] = [];
			centers.forEach((center) => {
				mappedCenter.push({
					id: center.id,
					name: center.name,
					type: center.type
				});
			});
			this.facade.dataStorageService.setParam(
				'listCenterViewableInPlanning',
				mappedCenter
			);
		});
	}

	getMessagingNotifications() {
		this.facade.notificationService
			.getMessageNotifications(this.facade.dataStorageService.getUser()?.id)
			.subscribe((notifications) => {
				this.listNotification = notifications;
				this.listNotification.sort();
			});
	}

	initializeBox() {
		this.boxList.push(
			{
				colorId: 1,
				value: 47,
				units: '%',
				title: 'mission(s)',
				subtitle: 'affectée(s)'
			},
			{
				colorId: 2,
				value: 51,
				units: '%',
				title: 'spécialité(s)',
				subtitle: 'satisfaite(s)'
			},
			{
				colorId: 3,
				value: 475,
				units: 'km',
				title: 'parcouru(s)',
				subtitle: ''
			},
			{
				colorId: 4,
				value: 123,
				units: 'h.',
				title: 'de travail',
				subtitle: 'effectif'
			}
		);
	}

	initDashboardVariables() {
		this.displayMapButton = false;
		this.currentWeekNumber = this.dateUtils.getWeekNumber(this.today);
		this.nextWeekNumber = this.dateUtils.getWeekNumber(
			new Date(this.today.getTime() + 7 * 24 * 60 * 60 * 1000)
		);
	}

	validerPlanning(weekNumber: number) {
		this.facade.dataStorageService.setParam(
			'planningValidationRedirected',
			true
		);
		this.facade.dataStorageService.setParam(
			'planningValidationRedirectedWeekNumber',
			weekNumber
		);

		this.router.navigate(['/planning']);
	}

	buildSolutionPlanning(weekNumber: number) {
		this.facade.dataStorageService.setParam(
			'planningBuildSolutionRedirected',
			true
		);
		this.facade.dataStorageService.setParam(
			'planningBuildSolutionRedirectedWeekNumber',
			weekNumber
		);

		this.router.navigate(['/planning']);
	}
}
